import DatePicker from '../../../shared/DatePicker'
import CustomButton from '../../../shared/CustomButton'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import DropdownField from '../../../shared/DropdownField'
import { useSelector, useDispatch } from 'react-redux'
import TextInput from '../../../shared/TextInput'
import { setList } from '../../../redux/slices/AppSlice'
import { fetchData } from '../../../helpers/fetchData'
import { useEffect, useState } from 'react'
import { getDepartmentList } from '../../../services/ApiMethods'
import toast from 'react-hot-toast'
import { validateOneMonthRange, getOneMonthMaxDate, getMinDate } from '../../../utils/dateRangeValidation'

function Filters({
  payloadData,
  setPayloadData,
  requestReport,
  responseReport,
  showDepartment = true,
  showCashInvoiceNumber = true,
  maxRangeDays = null,
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { list } = useSelector(state => state?.app)
  const [departmentList, setDepartmentList] = useState([])
  const [departmentLoading, setDepartmentLoading] = useState(false)

  const handleChange = event => {
    const { name, value } = event.target || {}

    setPayloadData(prevValues => ({
      ...prevValues,
      [name]: value,
    }))
  }

  const handleApply = async () => {
    if (maxRangeDays && !validateOneMonthRange(payloadData?.start_date, payloadData?.end_date, t)) {
      return
    }
    await requestReport(payloadData)
  }

  const handleReset = async () => {
    const payload = {
      end_date: moment().toDate(),
      start_date: moment().subtract(1, 'day').toDate(),
      created_by: '',
      ...(showCashInvoiceNumber ? { cash_invoice_number: '' } : {}),
      ...(showDepartment ? { department_id: '' } : {}),
    }
    setPayloadData(payload)
    await requestReport(payload, payload?.filters?.status)
  }

  useEffect(() => {
    const fetchReceptionists = async () => {
      if (list?.receptionists?.length > 0) return
      try {
        const response = await fetchData('GET', '/v3/invoices/getCreators', {})
        if (response?.data) {
          const _receptionists = response.data.map(receptionist => ({
            ...receptionist,
            label: receptionist?.staff_info?.user?.fullname
              ? `${receptionist?.staff_info?.user?.fullname} (${receptionist.created_by})`
              : receptionist.created_by,
            employee_id: receptionist.created_by,
          }))
          dispatch(setList({ key: 'receptionists', value: _receptionists }))
        }
      } catch (error) {
        console.error('Error fetching receptionists:', error)
      }
    }
    fetchReceptionists()
  }, [dispatch, list?.receptionists])

  useEffect(() => {
    if (showDepartment) {
      getDepartmentList(setDepartmentLoading, setDepartmentList)
    }
  }, [showDepartment])

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex  items-center gap-2">
        <DatePicker
          name="start_date"
          useFormik={false}
          className="mt-1"
          value={payloadData?.start_date}
          onChange={handleChange}
          placeholder={t('Selectstartdate')}
          format="YYYY-MM-DD"
        />

        <DatePicker
          name="end_date"
          useFormik={false}
          className="mt-1"
          value={payloadData?.end_date}
          onChange={handleChange}
          placeholder={t('Selectenddate')}
          format="YYYY-MM-DD"
          minDate={maxRangeDays ? getMinDate(payloadData?.start_date) : null}
          maxDate={maxRangeDays ? getOneMonthMaxDate(payloadData?.start_date) : null}
        />

        <DropdownField
          parentClass="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2"
          placeholder={`${t('Select')} ${t('receptionist')}`}
          className="!mb-0"
          name="created_by"
          filter
          useFormik={false}
          options={list.receptionists}
          optionLabel="label"
          optionValue="employee_id"
          value={payloadData?.created_by}
          onChange={handleChange}
        />

        {showDepartment && (
          <DropdownField
            parentClass="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-2"
            placeholder={`${t('Select')} ${t('Department')}`}
            className="!mb-0"
            name="department_id"
            filter
            useFormik={false}
            options={departmentList}
            optionLabel="name_en"
            optionValue="id"
            value={payloadData?.department_id}
            onChange={handleChange}
            loading={departmentLoading}
          />
        )}

        {showCashInvoiceNumber && (
          <TextInput
            name="cash_invoice_number"
            value={payloadData?.cash_invoice_number || ''}
            handleChange={handleChange}
            placeholder={t('Cash Invoice Number')}
            useFormik={false}
            parentClass="!mt-1"
            className="h-[35px] w-[200px] mb-0"
          />
        )}
      </div>

      <div className="flex items-center gap-2 ml-auto">
        <CustomButton
          //label={t('ApplyFilters')}
          title={t('ApplyFilters')}
          buttonType="primary"
          icon="pi pi-filter"
          className="w-fit h-[35px]"
          onClick={handleApply}
        />
        <CustomButton
          //label={t('Reset')}
          title={t('Reset')}
          buttonType="reset"
          icon="pi pi-sync"
          className="w-fit h-[35px]"
          onClick={handleReset}
        />
      </div>
    </div>
  )
}

export default Filters
